import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

const getToken = () => {
    const storedToken = localStorage.getItem("token");

    if (!storedToken) {
        return "";
    }

    try {
        return JSON.parse(storedToken) || "";
    } catch (error) {
        return "";
    }
};

function connectToSocket() {
    const token = getToken();
    const socket = openSocket(getBackendUrl(), {
      transports: ["polling", "websocket"],
      reconnection: true,
      autoConnect: Boolean(token),
      auth: { token },
    });

    const refreshSocketToken = () => {
        const nextToken = getToken();

        socket.auth = { token: nextToken };

        if (!nextToken) {
            socket.disconnect();
            return;
        }

        if (!socket.connected) {
            socket.connect();
        }
    };

    socket.on("connect_error", refreshSocketToken);
    socket.io.on("reconnect_attempt", refreshSocketToken);
    window.addEventListener("token:refreshed", refreshSocketToken);
    socket.on("disconnect", () => {});

    return socket;
}

export default connectToSocket;
